// Ribbons — rows turned about their length to face the camera (upright at walls 1), across the view at yaw (angle) 270, slicing a sea of three waves the camera travels over.

export default {
	name: 'ribbons',
	label: 'Ribbons',
	description: 'Rows of ribbons slicing a sea of waves, seen from any height and direction',

	expose: {
		speed: {
			tip: 'Rows travelling toward the camera, the camera flying over the sea; negative, away from it',
			initial: 0,
			minimum: -16,
			maximum: 16,
			step: 0.01,
			period: 2,
		},
		zoom: {
			tip: 'Zooms the rows and their waves',
			minimum: 0.25,
			maximum: 4,
		},
		angle: {
			tip: 'Yaw: turns the rows on the ground: at 270° they face the camera, at 0° they run away from it as lanes',
			initial: 270,
		},
		walls: {
			tip: 'Ribbons turned to face the camera at 0 (lanes running away lie down), all standing upright at 1',
			initial: 0,
		},
		start: {
			tip: 'How far ahead of the camera the rows begin: a field seen from its edge',
			initial: 0,
		},
		enclose: {
			tip: 'Open rows at 0; at 1 each row closes into a loop round the frame, the rows nesting inward',
			initial: 0,
			step: 0.01,
		},
		perspective: {
			tip: 'How much the far rows shrink: 0 shows every row the same size',
			initial: 0.5,
			maximum: 6,
		},
		tilt: {
			tip: 'Camera pitch: level at 0, looking straight down at 90',
			initial: 0,
			step: 0.1,
		},
		elevation: {
			tip: 'Height the camera looks from; 0 is ground level',
			initial: 0,
			minimum: -80,
			maximum: 200,
			step: 0.1,
		},
		count: {
			tip: 'Number of rows, centred on the frame; rows travelling enter at one edge and fade out at the other',
			initial: 5,
		},
		width: {
			tip: 'Width of each ribbon, at most the spacing',
			initial: 12,
			minimum: 0.25,
			maximum: 250,
			step: 0.05,
		},
		spacing: {
			tip: 'From one row’s centre to the next',
			initial: 18,
			minimum: 0,
			maximum: 250,
			step: 0.1,
		},
		grow: {
			tip: 'Near rows wider, far rows narrower above 0, the other way below it, at any perspective; never wider than the spacing',
			initial: 0,
		},
		hill_rows: {
			tip: 'How fast the sea changes from one row to the next',
			initial: 0.1,
		},
		wave_direction: {
			tip: 'Which way the waves roll: 0° along the ribbons, 90° from row to row',
			initial: 0,
		},
		parallax: {
			tip: 'Each row nearer runs the waves this many times as fast as the one behind, whatever the perspective',
			initial: 1,
		},
		fill: {
			tip: 'Extends each row down from its crest to the bottom of the frame, opaque below the wave line',
			initial: 0,
		},
		wave_length: {
			tip: 'Length of the main waves',
			initial: 200,
			minimum: 50,
			maximum: 1000,
		},
		wave_height: {
			tip: 'Height of the main waves',
			initial: 25,
			maximum: 50,
		},
		wave_speed: {
			tip: 'How fast the main waves roll along Wave Direction; the 2nd and 3rd waves move with it',
			initial: 40,
			minimum: -300,
			maximum: 300,
		},
		wave_b_length: {
			tip: 'Length of the long swell',
			initial: 600,
			minimum: 200,
			maximum: 2000,
		},
		wave_b_height: {
			tip: 'Height of the long swell',
			initial: 0,
			maximum: 50,
		},
		wave_b_speed: {
			tip: 'The swell’s speed, times Wave Speed',
			initial: 1.75,
			minimum: -2,
			maximum: 3,
		},
		wave_c_length: {
			tip: 'Length of the short chop',
			initial: 80,
			minimum: 50,
			maximum: 200,
		},
		wave_c_height: {
			tip: 'Height of the short chop',
			initial: 0,
			maximum: 20,
		},
		wave_c_speed: {
			tip: 'The chop’s speed, times Wave Speed',
			initial: 0.62,
			minimum: -2,
			maximum: 3,
		},
		fog: {
			tip: 'How fast the rows fade with distance',
			initial: 0.1,
			maximum: 1,
			step: 0.01,
		},
		color: {
			tip: 'One end of the ribbons’ colour range',
			initial: '#ff5e62',
		},
		color_b: {
			label: 'Color 2',
			tip: 'The other end of the colour range',
			initial: '#ffb547',
		},
		spread: {
			tip: 'Number of colours from Color to Color 2',
			initial: 5,
		},
		repeat: {
			tip: 'Ramp restarts the palette, Mirror walks back',
			initial: 1,
		},
		wash: {
			tip: 'Scrolls the palette through the rows, colours per second',
			initial: 0,
			period: 1,
		},
		ground: {
			tip: 'Behind the ribbons: its colour and opacity; fog fades far rows into it',
			initial: '#00000000',
		},
	},

	lock: { rows: 1, gap: 0 },
	range: { fit: [0, 1], rounding: [0, 1], gap: [0, 1] },
}
